module.exports = __webpack_public_path__ + "static/media/Team-2.38d50024.jpg";